/**
 * A vendor's tagline: one factual line about what the vendor sells, written by
 * the vendor (dashboard Settings > Business profile) or by Lusuku staff, and
 * returned as `tagline` on every restaurant, shop/wholesaler, pharmacy and
 * brand row (server: models/shared/vendorTaglineField.js).
 *
 * Returns the line, or null when the vendor has not written one. It is never
 * replaced with anything else: no generated copy, no cuisine or "type of
 * goods" standing in for it. A card with no tagline simply has no tagline.
 */
export const vendorTaglineOf = (vendor) => {
  const text =
    typeof vendor?.tagline === "string"
      ? vendor.tagline.replace(/\s+/g, " ").trim()
      : "";
  return text || null;
};
